import {
  checkNullObj,
  getDateText,
  getLocalText,
  useDblIntl
} from '@/pages/datalab/utils/utils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import React, {useEffect, useLayoutEffect, useMemo, useRef, useState,} from 'react';
import {useUpdateEffect,useDebounceFn, useSetState} from 'ahooks';
import {isEmpty} from 'lodash-es';
import {Bubble, Justify, Radio, Select, SelectOptionWithGroup, Icon, notification} from 'tea-component';
import {connect} from 'dva';
import './index.scss';

import {history, useIntl, useSelector, useLocation, getLocale} from "umi";
import ChartDropdown from '@/pages/datalab/components/CustomComponents/ChartDropdown';
import LineChart from '@/pages/datalab/components/CustomComponents/Chart/components/LineChart';
import MapChart from '@/pages/datalab/components/CustomComponents/Chart/components/MapChart';
import AnalysisPieChart from '@/pages/datalab/components/CustomComponents/Chart/components/AnalysisPieChart';
import StackBarChart from '@/pages/datalab/components/CustomComponents/Chart/components/StackBarChart';
import BarChart from '@customComp/Chart/components/BarChart';
import TableAnalytics from '@/pages/datalab/components/CustomComponents/TableAnalytics/index';
import {IAliTableAnalyticsRef} from '@customComp/AliTableAnalytics/types';
import {CHART_OLD_NAMESPACE} from '@/pages/datalab/models/namespaces';
import customDashboatdDownload from '@/pages/datalab/utils/customDownload';
import { preparePercentAxisChartDownloadTable } from '@/pages/datalab/utils/enrichPercentAxisChartDownloadData';
import { ChartType, type TChartType } from '@dbl/core/chart';
import { DateFormatString } from '@dbl/core/date';
import { buildRightChartConfig } from './buildRightChartConfig';
// import BigDataBar from "@customComp/Chart/components/BigDataBar";
import {ChartRef} from "@customComp/Chart/_config/_interface";
import {namespace as ExplorationNamespace} from "@/pages/datalab/pages/BehaviorAnalysis/ExplorationAnalysis/model";
import NumberTrendWrap from "./NumberTrendWrap";
// import BigDataLineChart from '@/pages/datalab/components/CustomComponents/Chart/components/BigDataLineChart';
import DimNumberTrendWrap from "./DimNumberTrendWrap";

import ConfirmModal from '@/pages/aigc/pages/Text2SQL/components/RelevantTable/components/ConfirmModal';

import {isSafari} from '@/pages/intelligence/utils/common';
import {getDownloadTaskId} from '@/pages/intelligence/services/download';
import {getBasePath} from '@/utils/utils';
import moment from 'moment';
import { usePanelActions } from '../ChartSettingsV2/ChartSettingsPanel/hooks/usePanelActions';
import { useChartIconVisible } from '../ChartSettingsV2/hooks/useChartIconVisibility';
import { useChartSettingsSelector } from '../ChartSettingsV2/context';
import { buildCustomizeSettingForApi } from '../ChartSettingsV2/services/api-upload';
import MixedChart from '@customComp/Chart/components/MixedChart';
import PortPage from "@/pages/datalab/pages/Multidimensional/Analysis/components/GuideOperation/PortPage";
import NoData from "@/pages/datalab/pages/Multidimensional/Analysis/components/GuideOperation/NoData";
import {AxiosRequestConfig} from "axios";
import { createTokenAwareFunction, ITokenData } from '@dbl/services/common';
import NewFeatureBubbleWrap from "@/pages/datalab/components/NewFeatureBubble/NewFeatureBubbleWrap";
import TableSortIcon from "../../../../../components/ChartCardIconButtons/TableSortIcon";
import {dropPageBtnPoints} from "@/pages/datalab/utils/buiredDatalabBtnPoints/dropPageBtnPoint";
import WordCloudChart from '@customComp/Chart/components/WordCloudChart';
import HorizontalBarChart from '@customComp/Chart/components/HorizontalBarChart';
import BigNumberChartWrap from './BigNumberChartWrap';
import VsIcon from "@/pages/datalab/components/ChartCardIconButtons/VsIcon";
import PercentStackBarChart from '@customComp/Chart/components/PercentStackBarChart';
import PercentLineChart from '@customComp/Chart/components/PercentLineChart';
import { ChartCalculateMode } from '@dbl/core/chartEditor';
import { DATALAB_ANALYSIS_ERROR_CODE } from '@dbl/core/global';
import { buildColumnSortOrderCodes } from '@/pages/datalab/pages/Multidimensional/Analysis/components/ChartSettingsV2/linkage/qbFields/qbLinkage/handlers/columnSort/untils/keys';
import ChartTypeSwitchBar from './ChartTypeSwitchBar';
import Loading from '@/pages/dashboard/components/Loading';
import useChartTypeCacheSignature from '@/pages/datalab/pages/Multidimensional/Analysis/hooks/useChartTypeCacheSignature';

type TLowLimitKey = 'en' | 'zh' | 'name';
const lowEnumerate: { [key in TLowLimitKey]: string | number }[] = [
  {
    en: '2,000 Rows',
    zh: '2,000行',
    name: 2000
  },
  {
    en: '5,000 Rows',
    zh: '5,000行',
    name: 5000
  },
  {
    en: '50,000 Rows',
    zh: '50,000行',
    name: 50000
  },
  {
    en: '100,000 Rows',
    zh: '100,000行',
    name: 100000
  },
  {
    en: '1,000,000 Rows',
    zh: '1,000,000行',
    name: 1000000
  }
];
const iframeInfo: {token?: string; dashboardId?: string;} = {};

const downloadWithTokenHttp = createTokenAwareFunction<
[api: string, params: any, config?: AxiosRequestConfig],
[api: string, params: any],
string
>(
  getDownloadTaskId,
  (tokenData: ITokenData, api: string, params: any): [string, any, AxiosRequestConfig?] => {
    iframeInfo.token = tokenData.token;
    iframeInfo.dashboardId = tokenData.dashboardId;
    const newConfig: AxiosRequestConfig = {
      // baseURL: tokenData.origin,
      headers: { Authorization: tokenData.token },
      noAuth: true,
    };
    
    const newParams = {
      ...params,
      game_code: tokenData.gameCode,
      dashboard_id: tokenData.dashboardId,
      system: undefined,
    };
    return [api, newParams, newConfig];
  }
);

export default connect((state: any, ownProps: { namespace: string; }) => {
  const { namespace } = ownProps;
  const { chartData, table, condition, dataTables, dataTableJoinRelations, userPackages, analysisRunning, columnDimensions, columnMetrics, columnRawColumns, columnX, columnUserFilters, hasUserFilters, gameCode, chartType, statisticalMetrics, hashEqualForAnalysis, save_column_infos: saveColumnInfos, mode, rowLimit, trendStatus, analysisRefreshRunning, visibleSearch } = state[namespace];
  
  return {
    chartData,
    condition,
    dataTables,
    dataTableJoinRelations,
    userPackages,
    analysisRunning,
    analysisLoading: state.loading.effects[`${namespace}/getDataAnlysis`],
    analysisRefreshRunning,
    columnDimensions,
    columnMetrics,
    columnRawColumns,
    hasUserFilters,
    columnX,
    columnUserFilters,
    table,
    gameCode,
    chartType,
    statisticalMetrics,
    saveColumnInfos,
    hashEqualForAnalysis,
    mode,
    rowLimit,
    trendStatus,
    visibleSearch,
    currentGame: state?.datalab?.currentGame,
  };
})(AnalysisLineChart);

export function AnalysisLineChart(props: any) {
  const {
    saveColumnInfos,
    chartData,
    filtersArr,
    filterCompares,
    namespace,
    columnDimensions,
    columnMetrics,
    columnRawColumns,
    columnX,
    columnUserFilters,
    hasUserFilters,
    gameCode,
    table,
    isOnlyShowPie, // 维度没有日期的时候, 是否只显示饼图
    chartType,
    statisticalMetrics,
    // isBigBar,
    // hashEqualForAnalysis,
    rowLimit,
    analysisLoading,
    analysisRefreshRunning,
    condition,
    currentGame,
    compareTimeData,
    trendStatus,
    visibleSearch,
    // newFlag
    mode,
    dispatch,
  } = props;
  const location = useLocation();
  const isFromAdd = location?.query?.from === 'add' || !location?.query?.from;
  const reqParams = useSelector((state: any) => state[namespace]?.reqParams);
  const { dblFormatMessage: chartFormatMessage, isEn } = useDblIntl("chart");
  const tableRef = useRef<IAliTableAnalyticsRef>(null);
  // const [isHover, setIsHover] = useState(false);
  // newChartData是 为了图表中图例名称的中英转换
  // 当前选中的指标
  const [curMetrics, setCurMetrics] = useState<string>(statisticalMetrics || '');
  const [curMetricsName, setCurMetricsName] = useState<string>('');
  const [selectOption, setSelectOption] = useState<SelectOptionWithGroup[]>();
  // 当前选中图表（与页面/顶部 tab 一致）
  const [curChartType, setCurChartType] = useState(chartType || ChartType.StackBar);
  // 图表切换条的渲染类型
  const [chartSwitchRenderType, setChartSwitchRenderType] = useState<ChartType | null>(null);
  const { formatMessage } = useIntl();
  const [rowLimitAssemble, setRowLimitAssemble] = useSetState<Partial<{
    rowLimitModal: boolean;
    rowLimitValue: number;
    fileFormat: string;
  }>>({
    rowLimitModal: false,
    rowLimitValue: 2000
  });  // 事件详情
  const [isEvent, setIsEvent] = useState(true);
  const { openPanel: handleOnChartsModal } = usePanelActions();
  const isShowChartsIcon = useChartIconVisible();
  // 从 model.ts 获取 columnSortToken
  const columnSortToken = useSelector((state: any) => state[CHART_OLD_NAMESPACE]?.columnSortToken);

  // 从 Context BASE 读取图表配置（设计文档原则一：全局单一存储，不区分图表类型）
  // DvaBaseInitializer 在页面加载时已从 DVA 初始化 BASE
  const baseFromContext = useChartSettingsSelector((s) => s.base);

  const rightChartConfig = useMemo(
    () =>
      buildRightChartConfig({
        chartType,
        baseFromContext,
        saveColumnInfos,
      }),
    [saveColumnInfos, chartType, baseFromContext],
  );

  /** 实际用于渲染的图表类型：chartSwitch 开启时可为 chartSwitchRenderType，否则为 curChartType */
  const displayChartType: TChartType = useMemo(() => {
    const baseChartSwitch = rightChartConfig?.chartSwitch;
    const inSwitchZone = [ChartType.Table, ChartType.Line, ChartType.Bar].includes(curChartType);
    if (baseChartSwitch?.show && inSwitchZone && chartSwitchRenderType !== null) {
      return chartSwitchRenderType;
    }
    return curChartType;
  }, [rightChartConfig?.chartSwitch, curChartType, chartSwitchRenderType]);
  const isChartSwitchCacheEnabled = useMemo(
    () =>
      !!rightChartConfig?.chartSwitch?.show &&
      Array.isArray(rightChartConfig?.chartSwitch?.chartTypes) &&
      rightChartConfig?.chartSwitch?.chartTypes?.length > 1,
    [rightChartConfig?.chartSwitch],
  );
  // 监听 column_sort_token 变化，触发表格列重排
  useUpdateEffect(() => {
    if (!columnSortToken) {
      return;
    }
    const columnSort = columnSortToken?.columnSort || [];
    if (!columnSort.length) {
      return;
    }
    const orderCodes = buildColumnSortOrderCodes(columnSort);
    if (orderCodes.length && tableRef.current) {
      tableRef.current.applyColumnOrder(orderCodes);
    }
  }, [columnSortToken]);
  
  useEffect(() => {
    // 更新选择的图表类型
    chartType && setCurChartType(chartType);
    setChartSwitchRenderType(null);
  }, [chartType]);
  
  useEffect(() => {
    // 更新选择的指标类型
    statisticalMetrics && setCurMetrics(statisticalMetrics);
  }, [statisticalMetrics]);
  
  const newChartData = useMemo(() => {
    try {
      if (isEmpty(chartData)) return chartData;
      // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars
      const { lineChart, metrics = [], pieChartData, metrics_en = [], columnName, eventLineChartSumData, lineChartSumData, mixedChartData, stackBarChart, axisList, barChart, rankData, mapData, wordCloudData, horizontalBarData, eventLineChart, percentStackBarData, percentLineChartData } = chartData;
      // [legacy · 重构可删] axisList：后端 axis_list 已废弃，PercentStackBar 用 percentStackBarData.xAxisData
      const dimension = columnName?.filter((v: any) => v?.type === 1);
      
      // 找到第一个aggregate有值的元素, aggregate 主要用于堆叠图的浮窗内部是否显示Total判断.
      const aggregation = columnName?.find((v: any) => v?.aggregate)?.aggregate;
      return {
        lineChart,
        stackBarChart,
        pieChartData,
        barChart,
        eventLineChart,
        mixedChartData,
        aggregation,
        metrics,
        metrics_en,
        dimension,
        axisList, // [legacy · 重构可删]
        rankData,
        columnName,
        mapData,
        wordCloudData,
        horizontalBarData,
        percentStackBarData,
        percentLineChartData,
      };
    } catch (e) {
      return chartData;
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartData, gameCode]);

  // eslint-disable-next-line no-nested-ternary
  const metrics = newChartData ? (newChartData.metrics ? newChartData.metrics : []) : [];
  useEffect(() => {
    if (metrics && metrics.length > 0) {
      const options = metrics.map((name: any) =>
        // let metricsName = isEn ? (chartData?.metrics_en?.[index] || name) : name;
        ({
          value: name,
          text: name?.replace(/(t[0-2]_)/, ''), // 指标名称不需要中英文切换展示
        })
      );
      setSelectOption(options);
      const cur = options.find((opt: {value: string;}) => opt.value === curMetrics) || options[0];
      setCurMetricsName(cur?.text);
      setCurMetrics(cur?.value);
      props.dispatch({
        type: `${namespace}/saveMetrics`,
        payload: {
          statisticalMetrics: cur?.value
        },
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metrics, isEn]);
  
  // 取到第一个指标字段信息
  const metricInfo = newChartData?.columnName?.find((opt: {name: string;}) => opt?.name === metrics[0]) || {};

  // 是否隐藏图表
  const {isHideChart, noData} = useMemo(() => {
    if (isEmpty(newChartData)) return { isHideChart: true   };
    switch (chartType) {
      case ChartType.Table: {
        return {
          isHideChart: !table,
          noData: table && (table?.actualCount === 0)
        };
      }
      case ChartType.StackBar: {
        return {
          isHideChart: !newChartData?.stackBarChart,
          noData: isEmpty(newChartData?.stackBarChart?.seriesData),
        };
      }
      case ChartType.Bar: {
        return {
          isHideChart: !newChartData?.barChart,
          noData: isEmpty(newChartData?.barChart?.seriesData),
        };
      }
      case ChartType.Line: {
        return {
          isHideChart: newChartData?.lineChart === undefined,
          noData: isEmpty(newChartData?.lineChart?.seriesData),
        };
      }
      case ChartType.MixedChart: {
        return {
          isHideChart: newChartData?.mixedChartData === undefined,
          noData: isEmpty(newChartData?.mixedChartData),
        };
      }
      case ChartType.EventLine: {
        return {
          isHideChart: newChartData?.eventLineChart === undefined,
          noData: isEmpty(newChartData?.eventLineChart?.seriesData),
        };
      }
      case ChartType.Pie: {
        return {
          isHideChart: newChartData?.pieChartData === undefined,
          noData: isEmpty(newChartData?.pieChartData),
        };
      }
      case ChartType.BigNumber: {
        return {
          isHideChart: chartData.bigNumberChart === undefined,
          noData: !(chartData.bigNumberChart?.length > 0),
        };
      }
      case ChartType.Trend: {
        return {
          isHideChart: chartData.lineData === undefined,
          noData: false,
        };
        // return !chartData.trend_metric || !chartData.lineData;
      }
      case ChartType.DimNumberTrend: {
        return {
          isHideChart: chartData.rankData === undefined,
          noData: isEmpty(chartData.rankData) && isEmpty(chartData?.lineData) && isEmpty(chartData?.trend_metric),
        };
      }
      case ChartType.Map: {
        // TODO 后面增加判断
        return {
          isHideChart: !chartData.mapData, // 没有值 说明加载失败
          noData: false, // 产品要求没有数据也要显示地图, 所以这里一直返回false
        };
      }
      case ChartType.WordCloud: {
        return {
          isHideChart: chartData?.wordCloudData === undefined,
          noData: isEmpty(chartData?.wordCloudData?.data),
        };
      }
      case ChartType.HorizontalBarChart: {
        return {
          isHideChart: !newChartData?.horizontalBarData,
          noData: isEmpty(newChartData?.horizontalBarData),
        };
      }
      case ChartType.PercentStackBar: {
        return {
          isHideChart: !newChartData?.percentStackBarData,
          noData: isEmpty(newChartData?.percentStackBarData?.seriesData),
        };
      }
      case ChartType.PercentLine: {
        return {
          isHideChart: !newChartData?.percentLineChartData,
          noData: isEmpty(newChartData?.percentLineChartData?.seriesData),
        };
      }
      default: return {
        isHideChart: true,
        noData: true,
      };

    }
  }, [chartType, newChartData]);
  
  const download = () => {
    // 现在后端下载改为了前端下载，下载内容和表格数据保持一致、
    // 目前只有表格、柱状图、折线图、组合图、地图、词云调用后端接口
    if ([ChartType.Table, ChartType.Bar, ChartType.Line, ChartType.MixedChart, ChartType.Map, ChartType.WordCloud].includes(displayChartType)) {
      setRowLimitAssemble({
        rowLimitModal: true
      });
      return;
    }
    // 后端返回什么就下载什么, 不做额外的中英文翻译
    const downLoadConfig = preparePercentAxisChartDownloadTable({
      chartType: displayChartType,
      data: table?.data || [],
      columnName: table?.columnName || [],
    });
    const {name = 'Unnamed chart', nameCn = '未命名图表'} = history?.location?.query || {name: 'Unnamed chart', nameCn: '未命名图表'};
    // 确保 fileName 替换 `% /` 为 `_`
    const fileName = getLocalText(isEn, nameCn, name)?.replace(/[/%]/g, '_');
    customDashboatdDownload(downLoadConfig, fileName, isEn);
  };
  
  const isNoDate = useMemo(() => !columnDimensions.find((dim: any) => dim?.column_type?.toLowerCase() === "date") && isOnlyShowPie, [isOnlyShowPie, columnDimensions]);
  
  const pieChartTitle = useMemo(() => {
    const timeFilter = filtersArr?.filter((item: any) =>  item?.column_type === "date") || [];
    const compareDateFilter = filterCompares?.filter((item: any) =>  item?.column_type === "date") || [];
    const timeRangeVal = [];
    if (timeFilter?.length > 0) {
      const dateType = timeFilter?.[0]?.dateType;
      const dateRange = timeFilter?.[0]?.column_value;
      const from = timeFilter?.[0]?.from;
      // @ts-ignore
      const dateFormat = DateFormatString[timeFilter?.[0]?.to_date_format || 'YYYYMMDD'];
      const timeRange = getDateText({dateType, dateRange, dateFormat, lastCount: timeFilter?.[0]?.lastCount, from});
      timeRangeVal.push(timeRange?.join(' ~ ') || '');
    }
    
    if(compareDateFilter?.length > 0) {
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for(let i=0;i<compareDateFilter.length;i++) {
        const item = compareDateFilter[i];
        const dateType = item?.dateType;
        const dateRange = item?.column_value;
        const from = item?.from;
        // @ts-ignore
        const dateFormat = DateFormatString[item?.to_date_format || 'YYYYMMDD'];
        const timeRange = getDateText({dateType, dateRange, dateFormat, lastCount: item?.lastCount, from});
        timeRangeVal.push(timeRange?.join(' ~ ') || '');
      }
    }
    return timeRangeVal;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filtersArr || {}),JSON.stringify(filterCompares || {})]);

  const {
    filterSignature,
    cacheSignatureMap,
    updateCacheSignature,
    updateCacheSignatureByFilters,
  } = useChartTypeCacheSignature({
    enabled: isChartSwitchCacheEnabled,
    filtersArr,
    table,
    chartData,
    displayChartType,
  });
  
  const chartRef: React.MutableRefObject<ChartRef | null> = useRef(null);
  useLayoutEffect(() => {
    const observer = new ResizeObserver(() => {
      const chart = chartRef?.current?.instance?.();
      chart?.resize();
    });
    
    const targetElement = document.querySelector('.table-analysis-chart');
    targetElement && observer.observe(targetElement as Element);
    return () => {
      observer.disconnect();
    };
  }, [table]);
  
  const resetRowLimitAssemble=()=>{
    setRowLimitAssemble({
      rowLimitModal: false,
      rowLimitValue: 2000,
      fileFormat: 'excel',
    });
  };
  const { run: handleOnDownLoadModal } = useDebounceFn(
    () => {
      const urlSearchParamsName = history?.location?.query || {};
      const fileName = getLocalText(isEn, urlSearchParamsName?.nameCn, urlSearchParamsName?.name, isEn ? 'Unnamed chart' : '未命名图表');
      const { rowLimit, rowlimit, row_limit } = urlSearchParamsName || {};
      // 替换 `% /` 为 `_`
      openCommonDataLabDownloadPage({
        ...reqParams,
        // 下载类型根据顶部tab选中的类型（图表类型切换中可能修改了chartType参数）
        chart_type: chartType?.replace('Chart', '')?.toLowerCase(), 
        sorts: saveColumnInfos?.tempData?.sorts || saveColumnInfos?.sorts || [],
        language: getLocale(),
        pagesize: Number(rowLimit || rowlimit || row_limit) || rowLimitAssemble.rowLimitValue,
        max_size: Number(rowLimit || rowlimit || row_limit) || rowLimitAssemble.rowLimitValue,
        file_format: rowLimitAssemble.fileFormat ?? 'excel',
        // TODO:这个name如何定义呢，待和产品确认。如果是add的情况下一天
        "file_name": fileName?.replace(/[/%]/g, '_')
      }).finally(() => {
        resetRowLimitAssemble();
      });
    }, {
      wait: 500
    }
  );
  const isOverLimit =useMemo(()=>
    table?.actualCount >= rowLimit
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ,[analysisLoading,table?.actualCount]);
  // ;
  const metricIsAllPercent = condition?.metrics?.reduce((acc: boolean, item: { column_type: string; }) => acc && item.column_type === 'percent', true);

  // 卡片类型组件把下载放到组件内部
  const isCardType = useMemo(() => [ChartType.Trend,ChartType.BigNumber,ChartType.DimNumberTrend]?.includes(curChartType),[curChartType]);
  const headerRight = <>
    {
      [ChartType.BigNumber].includes(curChartType) ? (<VsIcon
        openSingle={curChartType === ChartType.Table}
        className={'table-analysis-iconbox'}
        active={compareTimeData?.defaultCompareTimes?.length > 0}
        defaultCompareTimes={compareTimeData?.defaultCompareTimes}
        baseTimeRange={compareTimeData?.baseTimeRange}
        baseTimeName={compareTimeData?.baseTimeName}
        timeGranularity={compareTimeData?.timeGranularity}
        onConfirm={(newCompareTimes)=> {
        
          // 修改上传中筛选条件的参数
          const newFilters = filtersArr.map((item: any) => {
            if (item.id === compareTimeData?.filterId) {
              return {
                ...item,
                compareTimes: newCompareTimes
              };
            }
            return item;
          });
        
          props.dispatch({
            type: `${namespace}/save`,
            payload: {
              columnFilters: newFilters
            }
          });
        
          props.dispatch({
            type: `${namespace}/getDataAnlysis`,
            payload: {
              isEn,
              gameCode,
              newColumnFilters: newFilters,
              isNoSave: true,
            },
            callback: (payload: {errorMsg: string;}) => {
              if (payload?.errorMsg && payload?.errorCode !== 40005) {
                notification.error({
                  className: 'dbl-analysis-msg',
                  description: DATALAB_ANALYSIS_ERROR_CODE?.includes(payload?.errorCode) ? formatMessage({id: `dbl_error_${payload?.errorCode || '1'}`}, {name: payload?.errorData, msg: payload?.errorMsg}) : payload?.errorMsg,
                  duration: 3000
                });
              }
            }
          });
        }}
      />) : ''
    }
    <div className="table-analysis-felx">
      {  isOverLimit &&  <div className={`table-analysis-rows`}><Icon type="warning" style={{
        marginBottom: '3px',
        marginRight: '5px',
      }} />  {chartFormatMessage('row')}</div>}
      <Bubble dark content={chartFormatMessage('download')}>
        <i className="table-analysis-iconbox" onClick={download}>
          <SvgIcon className="table-analysis-icon" type="download" />
        </i>
      </Bubble>
    </div>
  
  </>;

  const onStatusChange = (status: object) => {
    props.dispatch({
      type: `${namespace}/save`,
      payload: {
        trendStatus: {
          ...saveColumnInfos?.trendStatus,
          ...(trendStatus || {}),
          ...status,
        },
      },
    });
  };

  const tooltipMinTopPx = visibleSearch ? -300 : -140;

  // eslint-disable-next-line no-nested-ternary
  return isHideChart ? <PortPage /> : (
    noData ? (<NoData />) :
      (
        <div className="table-analysis-chart">
          {!isCardType ? (
            <Justify
              className="table-analysis-justify"
              left={
                namespace === ExplorationNamespace ? (
                  <div className="table-analysis-felx">
                    <div className="table-analysis-title">
                      {chartFormatMessage('statistical_metric')}
                    </div>
                    <Select
                      className="table-analysis-select"
                      appearance="button"
                      matchButtonWidth
                      options={selectOption}
                      value={curMetrics}
                      onChange={(value, context) => {
                        setCurMetricsName(
                          context.option?.text?.toString()
                            ? context.option?.text?.toString()
                            : '',
                        );
                        setCurMetrics(value);
                        props.dispatch({
                          type: `${namespace}/saveMetrics`,
                          payload: {
                            statisticalMetrics: value,
                          },
                        });
                      }}
                      placeholder={chartFormatMessage('select_placeholder')}
                    />
                    <span className={'table-analysis-limit-info'}>
                      {chartFormatMessage('limit_info')}
                    </span>
                    <Bubble dark content={chartFormatMessage('limit_bubble')}>
                      <span className={'table-analysis-felx-limit-info'}>
                        {' '}
                        <SvgIcon type={'alert-circle-action'} />
                      </span>
                    </Bubble>
                  </div>
                ) : (
                  ''
                )
              }
              right={
                <div className="table-analysis-felx">
                  <ChartTypeSwitchBar
                    table={table}
                    mode={mode}
                    chartData={chartData}
                    chartSwitch={rightChartConfig?.chartSwitch}
                    curChartType={curChartType}
                    chartType={displayChartType}
                    chartSwitchRenderType={chartSwitchRenderType}
                    namespace={namespace}
                    dispatch={dispatch}
                    isEn={isEn}
                    gameCode={gameCode}
                    columnDimensions={columnDimensions}
                    columnMetrics={columnMetrics}
                    filterSignature={filterSignature}
                    cacheSignatureMap={cacheSignatureMap}
                    onCacheSignatureUpdate={updateCacheSignature}
                    onSelectChartType={(type) => {
                      setChartSwitchRenderType(type);
                    }}
                  />
                  {namespace === ExplorationNamespace ? (
                    <ChartDropdown
                      curChartType={curChartType}
                      isNoDate={isNoDate}
                      onChange={(item: any) => {
                        setCurChartType(item.type);
                        props.dispatch({
                          type: `${namespace}/saveChartType`,
                          payload: {
                            chartType: item.type,
                          },
                        });
                      }}
                    />
                  ) : (
                    ''
                  )}
              
                  {   isOverLimit &&
				      <div className={`table-analysis-rows`}>  <Icon type="warning"  style={{
				        marginBottom: '3px',
				        marginRight: '5px',
				      }}/> {chartFormatMessage('row')}</div>}
                  {
                    namespace === 'Analysis/MultiAnalysis' && curChartType === ChartType.EventLine ?
                      <Bubble dark content={isEvent ? formatMessage({ id: 'common_show_event' }) : formatMessage({ id: 'common_hide_event' })}>
                        <i className="table-analysis-iconbox" onClick={()=>setIsEvent(!isEvent)}>
                          <SvgIcon className="table-analysis-icon" type={isEvent ? 'move-left' : 'move-right'} />
                        </i>
                      </Bubble> : ''
                  }
                  {
                    namespace === 'Analysis/MultiAnalysis' && ([ChartType.Line, ChartType.EventLine, ChartType.Bar].includes(curChartType) || (curChartType === ChartType.Table && mode === ChartCalculateMode.Aggregate) )&& compareTimeData.filterId ?
                      <VsIcon
                        openSingle={displayChartType === ChartType.Table}
                        className={'table-analysis-iconbox'}
                        active={compareTimeData?.defaultCompareTimes?.length > 0}
                        defaultCompareTimes={compareTimeData?.defaultCompareTimes}
                        baseTimeRange={compareTimeData?.baseTimeRange}
                        baseTimeName={compareTimeData?.baseTimeName}
                        timeGranularity={compareTimeData?.timeGranularity}
                        onConfirm={(newCompareTimes)=> {
                          let filterInfo;
                          // 修改上传中筛选条件的参数
                          const newFilters = filtersArr.map((item: any) => {
                            if (item.id === compareTimeData?.filterId) {
                              filterInfo = item;
                              return {
                                ...item,
                                compareTimes: newCompareTimes
                              };
                            }
                            return item;
                          });

                          props.dispatch({
                            type: `${namespace}/save`,
                            payload: {
                              columnFilters: newFilters
                            }
                          });

                          // upload 前按最新 filters 修正 column_sort：base 可能仍保留「对比时间」展示名，
                          // 与面板 getEffectiveColumnSort 不一致会导致计算接口 column_sort 错误
                          const customizeSetting = buildCustomizeSettingForApi(
                            {
                              chartType: displayChartType,
                              base: baseFromContext as Record<string, unknown>,
                              draft: {},
                              columnDimensions,
                              columnMetrics,
                              mode,
                            },
                            {
                              patches: { columnSortCompareTime: true },
                              columnFilters: newFilters,
                            },
                          );

                          props.dispatch({
                            type: `${namespace}/getDataAnlysis`,
                            payload: {
                              isEn,
                              gameCode,
                              newColumnFilters: newFilters,
                              isNoSave: true,
                              customizeSetting,
                              refreshType: displayChartType,
                            },
                            callback: (payload: {errorMsg: string;}) => {
                              if (payload?.errorMsg && payload?.errorCode !== 40005) {
                                notification.error({
                                  className: 'dbl-analysis-msg',
                                  description: DATALAB_ANALYSIS_ERROR_CODE?.includes(payload?.errorCode) ? formatMessage({id: `dbl_error_${payload?.errorCode || '1'}`}, {name: payload?.errorData, msg: payload?.errorMsg}) : payload?.errorMsg,
                                  duration: 3000
                                });
                              }
                              updateCacheSignatureByFilters(displayChartType, newFilters);
                              dispatch({
                                type: `${namespace}/save`,
                                payload: {
                                  analysisRunning: false,
                                  analysisRefreshRunning: false,
                                },
                              });
                            }
                          });
                        }}
                      /> : ''
                  }
                  {
                    namespace === 'Analysis/MultiAnalysis' && curChartType === ChartType.Table ?
                      (<TableSortIcon
                        className={'table-analysis-iconbox'}
                        onReset={() => {
                          const oldSorts = saveColumnInfos?.sorts || [];
                          tableRef?.current?.changeSorts(oldSorts);
                          props.dispatch({
                            type: `${namespace}/save`,
                            payload: {
                              save_column_infos: {
                                ...saveColumnInfos,
                                tempData: { // 临时存储 排序, 分页, 列宽等数据, 保存图表时再放到图表信息中
                                  ...saveColumnInfos?.tempData,
                                  sorts: oldSorts,
                                }
                              }
                            },
                          });
                          dropPageBtnPoints({
                            buttonId: '004',
                            buttonName: 'Reset Sort',
                            uid: currentGame?.game_code,
                            gameName: currentGame?.game_name,
                          });
                          
                        }}
                        onClear={() => {
                          tableRef?.current?.changeSorts([]);
                          props.dispatch({
                            type: `${namespace}/save`,
                            payload: {
                              save_column_infos: {
                                ...saveColumnInfos,
                                tempData: { // 临时存储 排序, 分页, 列宽等数据, 保存图表时再放到图表信息中
                                  ...saveColumnInfos?.tempData,
                                  sorts: [],
                                }
                              }
                            },
                          });
                          dropPageBtnPoints({
                            buttonId: '005',
                            buttonName: 'Clear Sort',
                            uid: currentGame?.game_code,
                            gameName: currentGame?.game_name,
                          });
                        }}
                      />) : ''
                  }
                  <SettingTips
                    key={ chartType }
                    {...{
                      chartFormatMessage,
                      isShowChartsIcon,
                      handleOnChartsModal,
                      chartType,
                    }}/>
                  <Bubble dark content={chartFormatMessage('download')}>
                    <i
                      className="table-analysis-iconbox"
                      onClick={download}
                    >
                      <SvgIcon className="table-analysis-icon" type="download" />
                    </i>
                  </Bubble>
                </div>
              }
            />
          ) : (
            ''
          )}
      
          {curChartType === ChartType.StackBar && (
            <StackBarChart
              tooltipMinTopPx={tooltipMinTopPx}
              chartData={newChartData?.stackBarChart || {}}
              metricInfo={metricInfo}
              // curMetrics={curMetrics}
              // curMetricsName={curMetricsName}
              ref={chartRef}
              // dimensions={newChartData?.dimension || []}
              incrementSum={['sum',"count","distinct"].includes(newChartData?.aggregation)}
              chartConfig={rightChartConfig}
              
              // curMetrics={curMetrics}
              curMetricsName={curMetricsName}
              metricNames={newChartData?.metrics || []}
              // isOnlyOneDimension={columnDimensions?.length <= 1}
              metricIsAllPercent={metricIsAllPercent}
              fieldInfos={newChartData?.columnName}
            />
          )}
          {curChartType === ChartType.PercentStackBar && (
            <PercentStackBarChart
              ref={chartRef}
              chartData={newChartData?.percentStackBarData || []}
              metricInfo={metricInfo}
              metrics={newChartData?.metrics || []}
              dimensions={newChartData?.dimension || []}
              chartConfig={rightChartConfig}
            />
          )}
          {curChartType === ChartType.PercentLine && (
            <PercentLineChart
              ref={chartRef}
              chartData={newChartData?.percentLineChartData || []}
              metricInfo={metricInfo}
              metrics={newChartData?.metrics || []}
              dimensions={newChartData?.dimension || []}
              chartConfig={rightChartConfig}
            />
          )}
          {
            curChartType === ChartType.HorizontalBarChart && (
              <HorizontalBarChart
                ref={chartRef}
                tooltipMinTopPx={tooltipMinTopPx}
                chartData={newChartData?.horizontalBarData || []}
                metricNames={metrics || []}
                dimensions={newChartData?.dimension || []}
                isOnlyOneDimension={columnDimensions?.length <= 1}
                chartConfig={rightChartConfig}
                fieldInfos={newChartData?.columnName}
                metricIsAllPercent={metricIsAllPercent}
              />
            )
          }
          {
            analysisRefreshRunning ? <Loading/> : ''
          }
          {displayChartType === ChartType.Bar && !analysisRefreshRunning &&
            (<BarChart
              ref={chartRef}
              tooltipMinTopPx={tooltipMinTopPx}
              chartData={newChartData?.barChart|| {}}
              metricNames={newChartData?.metrics || []}
              isOnlyOneDimension={columnDimensions?.length <= 1}
              metricIsAllPercent={metricIsAllPercent}
              chartConfig={rightChartConfig}
              compareDateCount={compareTimeData.defaultCompareTimes?.length || 0}
              fieldInfos={newChartData?.columnName}
              userFilterControls={hasUserFilters ? columnUserFilters : []}
            />)}
          {displayChartType === ChartType.Line && !analysisRefreshRunning && (
            <LineChart
              chartData={newChartData?.lineChart|| {}}
              ref={chartRef}
              tooltipMinTopPx={tooltipMinTopPx}
              metricNames={newChartData?.metrics || []}
              isOnlyOneDimension={columnDimensions?.length <= 1}
              metricIsAllPercent={metricIsAllPercent}
              chartConfig={rightChartConfig}
              compareDateCount={compareTimeData.defaultCompareTimes?.length || 0}
              fieldInfos={newChartData?.columnName}
              userFilterControls={hasUserFilters ? columnUserFilters : []}
            />
          )}
          {curChartType === ChartType.MixedChart && (
            <MixedChart
              chartData={newChartData?.mixedChartData || {}}
              metricNames={newChartData?.metrics || []}
              ref={chartRef}
              chartConfig={rightChartConfig}
              fieldInfos={newChartData?.columnName}
            />
          )}
          {curChartType === ChartType.EventLine && <LineChart
		      isEvent={isEvent}
            tooltipMinTopPx={tooltipMinTopPx}
		      eventData={chartData?.eventData || []}
		      chartData={newChartData?.eventLineChart || {}}
		      metricNames={newChartData?.metrics || []}
		      ref={chartRef}
	        isOnlyOneDimension={columnDimensions?.length <= 1}
            metricIsAllPercent={metricIsAllPercent}
		      chartConfig={rightChartConfig}
	        compareDateCount={compareTimeData.defaultCompareTimes?.length || 0}
	        fieldInfos={newChartData?.columnName}
	      />}
          {curChartType === ChartType.Pie && <AnalysisPieChart
            {...props}
		        chartData={newChartData?.pieChartData || []}
		        pieChartTitle={pieChartTitle}
		        curMetrics={curMetrics}
            metricInfo={metricInfo}
		        ref={chartRef}
            chartConfig={rightChartConfig}
	      />
          }
          {
            displayChartType === ChartType.Table && !analysisRefreshRunning && <TableAnalytics ref={tableRef} sortable isColumnResize isEn={isEn} table={table} chartConfig={rightChartConfig} saveTableState={(state) => {
              const { pageSize, sorts, columnWidths} = state || {};
              const newInfos = {...saveColumnInfos?.tempData};
              pageSize && (newInfos.savePaginAtion = pageSize);
              sorts && (newInfos.sorts = sorts);
              columnWidths && (newInfos.saveWidth = JSON.stringify(columnWidths));
              props.dispatch({
                type: `${namespace}/save`,
                payload: {
                  save_column_infos: {
                    ...saveColumnInfos,
                    // 临时存储 排序, 分页, 列宽等数据, 保存图表时再放到图表信息中
                    tempData: newInfos
                  }
                },
              });
            }}/>
          }
          {
            curChartType === ChartType.BigNumber &&
			      <BigNumberChartWrap
            	className={'table-analysis-chart-big-number'}
			        trendStatus={trendStatus}
			        onStatusChange={onStatusChange}
			        headerRight={headerRight}
			        isFromAdd={isFromAdd}
			        displayConfig={{
			          accuracy: metricInfo?.accuracy || 0,
			          unit: metricInfo?.unit || 'bmk',
			          columnType: metricInfo?.column_date_type,
			        }}
			        bigNumbers={chartData?.bigNumberChart}
			        title={curMetricsName}
			      />
          }
          {
            curChartType === ChartType.Trend &&
		      <NumberTrendWrap
			      chartData={chartData}
			      headerRight={headerRight}
		        isFromAdd={isFromAdd}
			      onStatusChange={onStatusChange}
			      filtersArr={filtersArr}
			      columnX={columnX}
			      oldTrendStatus={trendStatus}
	          metricInfo={metricInfo}
		      />
          }
          {
            curChartType === ChartType.DimNumberTrend &&
		      <DimNumberTrendWrap
			      chartData={chartData}
			      filtersArr={filtersArr}
	          columnX={columnX}
		        headerRight={headerRight}
		        isFromAdd={isFromAdd}
		        trendStatus={trendStatus}
		        onStatusChange={onStatusChange}
	          metricInfo={metricInfo}
		      />
          }
          
          {curChartType === ChartType.Map && (
            <MapChart
              chartData={newChartData?.mapData || {}}
              ref={chartRef}
              chartConfig={rightChartConfig}
              metricInfo={metricInfo}
            />
          )}
          
          {curChartType === ChartType.WordCloud && (
            <WordCloudChart
              chartData={newChartData?.wordCloudData?.data || []}
              metricInfo={newChartData?.wordCloudData?.metric_info || []}
              dimensions={newChartData?.dimension || []}
              ref={chartRef}
              chartConfig={rightChartConfig}
            />
          )}

          <ConfirmModal
            {...{
              visible: rowLimitAssemble.rowLimitModal,
              caption: formatMessage({ id: 'dbl_chart_modal_download_set' }),
              click: handleOnDownLoadModal,
              clone: () => resetRowLimitAssemble(),
              size: 580,
            }}
          >
            <DownLoadModalContent
              {...{
                radioValue: rowLimitAssemble.rowLimitValue,
                handleOnRadioChange: (value) =>
                  setRowLimitAssemble((prev) => {
                    return {
                      ...prev,
                      ...value,
                    };
                  }),
              }}
            />
          </ConfirmModal>
        </div>
      )
  );
}

export function checkIsChartDataNull(data: any[]): Boolean {
  if (checkNullObj(data) || data?.length === 0) {
    return true;
  }
  for (const item of data) {
    if (checkNullObj(item)) {
      return true;
    }
  }
  return false;
}
export const openCommonDataLabDownloadPage = async (params: any,apiUrl?: string | undefined) => {
  try {
    const api = apiUrl || '/api/v1/datalab/download_excel';
    if (isSafari()) {
      const page: any = window.open('', '_blank');
      const taskId = await downloadWithTokenHttp(api, params);
      page.location = `${location.origin}${getBasePath()}/datalab/download?entityType=${moment().format('YYYY_MM_DD HH_mm_ss')}&baseSystematicName=${'datalab'}&taskId=${taskId}&isShowMaxDownloadRowsTips${false}${iframeInfo.token ? `&token=${iframeInfo.token}&dashboardId=${iframeInfo.dashboardId}` : ''}`;
    } else {
      const taskId = await downloadWithTokenHttp(api, params);
      window.open(
        `${getBasePath()}/datalab/download?entityType=${moment().format('YYYY_MM_DD HH_mm_ss')}&baseSystematicName=${'datalab'}&taskId=${taskId}&isShowMaxDownloadRowsTips=${false}${iframeInfo.token ? `&token=${iframeInfo.token}&dashboardId=${iframeInfo.dashboardId}` : ''}`,
        '_blank',
      );
    }
  } catch (e) {
    console.warn(e);
  }
};


export const DownLoadModalContent = (
  { handleOnRadioChange, radioValue}: {
    handleOnRadioChange: (...args: any[]) => void;
    radioValue: string | number | undefined;
    isRaw?: boolean;
  }
) => {
  const { formatMessage, locale } = useIntl();

  return (<>
    <div className='low-container-waring'>
      {formatMessage({ id: 'dbl_chart_modal_download_warning' })}
    </div>
    <div className='low-container' style={{marginBottom: 10}}>
      <div className='low-container-title'>
        {formatMessage({ id: 'dbl_common_download_type' })}
      </div>
      <div className='low-container-list'>
        <Radio.Group defaultValue='xlsx'
          onChange={value => {
            handleOnRadioChange?.({fileFormat: value});
          }}>
          <Radio name={'xlsx'}>Excel</Radio>
          <Radio name={'csv'}>CSV</Radio>
        </Radio.Group>
      </div>
    </div>
    <div className='low-container'>
      <div className='low-container-title'>
        {formatMessage({ id: 'dbl_chart_modal_download_dataSource' })}
      </div>
      <div className='low-container-list'>
        <Radio.Group value={radioValue as string}
          onChange={value => {
            handleOnRadioChange?.({rowLimitValue: value});
          }}>
          {
            lowEnumerate.map(task => (
              <div key={task.name} className='low-container-item' >
                <Radio name={task.name as string}>{locale === "en-US" ? task.en : task.zh}</Radio>
              </div>
            ))
          }
        </Radio.Group>
      </div>
    </div>
  </>);
};

export const SettingTips = ({
  isShowChartsIcon,
  chartFormatMessage,
  handleOnChartsModal,
  chartType,
}: {
  isShowChartsIcon: boolean;
  chartFormatMessage: (...args: any[]) => string;
  handleOnChartsModal: (...args: any[]) => void;
  chartType: TChartType;
}) => {
  
  if (!isShowChartsIcon) return '';
  const defaultComp = (
    <i className="table-analysis-iconbox">
      <SvgIcon
        className="table-analysis-icon"
        type="set-up"
        onClick={handleOnChartsModal}
      />
    </i>
  );
  const content = chartFormatMessage('graph_settings');
  switch (chartType) {
    case ChartType.Line: return (<NewFeatureBubbleWrap
      featureConfig={{
        featureId: 'ReferenceLine',
        visible: chartType === ChartType.Line,
        style: { maxWidth: 390 }
      }}
      content={content}
    >{defaultComp}</NewFeatureBubbleWrap>);
    
    default: return (<Bubble
      dark
      content={content}
    >
      {defaultComp}
    </Bubble>);
  }
};